import Translate from '../../../src/core/Translate.js';
var id = 0;

class WidgetEventFormController {
	constructor(scope) {
		// scope.available

		this.objectId = 'WidgetEventForm' + (id++);

		this.events = scope.available.map(e => {
			return {
				'_event': e,
				'_name': this.getEventName(e),
				'action': null,
				'options': {
					'drilldown': 'default',
					'field': '테이블'
				}
			}
		});

		this.scope = scope;

	}

	setEvent(eventName, event) {
		var eventObj = this.events.filter(e => {
			return e._event === eventName;
		}).first();

		if(!eventObj) {
			eventObj = {};
		}

		eventObj.action = event.action;
		eventObj.options = event.options;

	}

	commit() {
		var arrObj = this.events.filter(e => {
			return !!e.action;
		}).map(e => {
			var obj = {};
			var options = {};

			// _ 붙은 속성은 private 이므로 무시한다.
			for(var key in e.options) {
				if(key.indexOf('_') !== 0) {
					options[key] = e.options[key];
				}
			}

			delete options['filter']

			// 저장될 형식에 맞춰 리턴
			/*
			 *  { click: { action: 'drilldown', options: {...} } }
			 */
			obj[e._event] = {
				'action': e.action,
				'options': options
			};
			return obj;
		});

		// 저장될 형식에 맞춰 combine
		/* [
		 *  { click: { action: 'query', options: {...} } }
		 *  { drag: { action: 'drilldown', options: {...} } }
		 * ]
		 * ==>
		 *  {
		 *    click: { action: 'query', options: {...} },
		 *    drag: { action: 'drilldown', options: {...} }
		 *  }
		 */
		var val = {};
		arrObj.forEach(obj => {
			Object.assign(val, obj);
		});

		// console.warn('---------->', val);

		this.ngModelController.$setViewValue(val);
	}

	getEventName(e) {
		if(e === 'drag') {
			return 'drag';
		}
		else if(e === 'click') {
			return 'click';
		}
	}
}

WidgetEventFormController.$inject = ['$scope'];

export default WidgetEventFormController;


// WEBPACK FOOTER //
// ./resources/WEB-INF/package/system/dashboard/WidgetEventFormController.js